import { useEffect, useState } from 'react'
import { colors } from '../colors'

interface LoginModalProps {
  isOpen: boolean
  onClose: () => void
}

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modal: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    padding: '24px',
    maxWidth: '320px',
    width: '90%',
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: '16px',
    right: '16px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    color: '#666666',
    cursor: 'pointer',
    padding: '0',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: '24px',
    lineHeight: '1.5',
    color: '#333333',
  },
  heartIcon: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '16px',
  },
  heartSvg: {
    width: '48px',
    height: '48px',
  },
  description: {
    fontSize: '14px',
    textAlign: 'center',
    color: '#666666',
    marginBottom: '24px',
    lineHeight: '1.5',
  },
  loginButton: {
    display: 'block',
    width: '100%',
    padding: '12px',
    backgroundColor: colors['keijiban-coral'],
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    marginBottom: '12px',
  },
  laterButton: {
    display: 'block',
    width: '100%',
    padding: '12px',
    backgroundColor: '#FFFFFF',
    color: '#666666',
    border: '1px solid #DDDDDD',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: 'normal',
    cursor: 'pointer',
    textAlign: 'center',
  },
}

const LoginModal: React.FC<LoginModalProps> = ({ isOpen, onClose }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  if (!mounted || !isOpen) return null

  const currentUrl = encodeURIComponent(window.location.href)
  const loginUrl = `/sessions/login_tokubai?rt=${currentUrl}`

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <button type="button" style={styles.closeButton} onClick={onClose} aria-label="閉じる">
          ×
        </button>
        
        <h2 style={styles.title}>
          ログインして<br />
          全ての機能を使ってみる
        </h2>

        <div style={styles.heartIcon}>
          <svg style={styles.heartSvg} viewBox="0 0 48 48" fill="none">
            <path
              d="M24 42L20.94 39.18C10.4 29.44 3.6 23.16 3.6 15.6C3.6 9.36 8.64 4.32 14.88 4.32C18.48 4.32 22.08 6.12 24 9.12C25.92 6.12 29.52 4.32 33.12 4.32C39.36 4.32 44.4 9.36 44.4 15.6C44.4 23.16 37.6 29.44 27.06 39.18L24 42Z"
              fill={colors['keijiban-coral']}
            />
          </svg>
        </div>

        <p style={styles.description}>
          気になる口コミにリアクションしたり、<br />
          フォローしたお店で絞り込みできます
        </p>

        <a href={loginUrl} style={styles.loginButton}>
          ログインする
        </a>

        <button type="button" style={styles.laterButton} onClick={onClose}>
          あとで
        </button>
      </div>
    </div>
  )
}

export default LoginModal
